module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/440.1cf1be8c.png";